export default __webpack_public_path__ + "scene1_3_bg0a98d5.png";